import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MoreFiltersData } from './more-filters.model';

@Component({
  template: `<miq-more-filters
    [dataFilters]="data"
    [isModal]="true"
    (filtersChange)="filtersChange($event)"
  ></miq-more-filters>`,
  standalone: false,
})
export class MoreFiltersDialogWrapperComponent {
  data: MoreFiltersData;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: MoreFiltersData,
    private dialogRef: MatDialogRef<MoreFiltersDialogWrapperComponent>
  ) {
    this.data = data;
  }

  filtersChange(userFilters): void {
    this.dialogRef.close(userFilters);
  }
}
